import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Icon from '../../common/Icon';
import NavigationDropdownDrawerButton from '../NavigationDropdownDrawerButton';
import globalTranslations from '../../../i18n/globalTranslations';

const DEFAULT_CLOSE_BUTTON = NavigationDropdownDrawerButton({
  label: (
    <span>
      <Icon name="times" />{' '}
      <FormattedMessage {...globalTranslations.closeTitle} />
    </span>
  ),
  color: 'primary',
  onClick: (context) => context.close(),
  key: '_default-close',
});

const KEY_CODES_TO_STOP = [13, 32, 38, 40];

const NavigationDropdownDrawer = ({
  label,
  children,
  className,
  toggleClassName,
  buttons,
  right,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const handleToggleKeyDown = (event) => {
    if (KEY_CODES_TO_STOP.includes(event.which || event.keyCode)) {
      event.stopPropagation();
    }
  };

  const buttonContext = {
    close: () => setOpen(false),
  };

  return (
    <Dropdown
      isOpen={open}
      toggle={() => setOpen((prev) => !prev)}
      nav
      a11y={false}
      className={classNames('NavigationDropdownDrawer', className)}
      {...props}
    >
      <DropdownToggle
        color="plain"
        nav
        caret
        tag="button"
        type="button"
        className={toggleClassName}
        onKeyDown={handleToggleKeyDown}
      >
        {label}
      </DropdownToggle>
      <DropdownMenu right={right}>
        {children}
        <div className="NavigationDropdownDrawer__hanging-buttons">
          {buttons.map((button) => button(buttonContext))}
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

NavigationDropdownDrawer.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.func,
  ]),
  className: PropTypes.string,
  toggleClassName: PropTypes.string,
  children: PropTypes.node,
  buttons: PropTypes.arrayOf(PropTypes.func),
  right: PropTypes.bool,
};

NavigationDropdownDrawer.defaultProps = {
  label: '',
  className: '',
  toggleClassName: '',
  children: [],
  buttons: [DEFAULT_CLOSE_BUTTON],
};

export default NavigationDropdownDrawer;
